Actor.create = function (device, type) {
    var actor = new Actor();

    actor.id = Utils.getNextDefaultId(device.actors, type.plugin, 1);
    actor.label = Utils.getNextDefaultLabel(device.actors, type.label, 1);
    actor.__device = device;
    actor.__type = type;
    actor.type = type.plugin;
    actor.configuration = {};

    for (var n in type.configuration) {
        if (type.configuration[n].defaultValue) {
            actor.configuration[type.configuration[n].id] = type.configuration[n].defaultValue;
        }
    }

    return actor;
};

Actor.bind = function (device, actor) {
    Utils.inheritMethods(actor, new Actor());

    actor.bind(device);

    return actor;
};

/**
 *
 */
function Actor() {
    /**
     *
     */
    Actor.prototype.bind = function (device) {
        this.__device = device;
        this.__type = device.getActorType(this.type);

        // Set default values

        if (this.configuration) {
            for (var n = 0; n < this.__type.configuration.length; ++n) {
                if (!this.configuration[this.__type.configuration[n].id]) {
                    this.configuration[this.__type.configuration[n].id] = this.__type.configuration[n].defaultValue;
                }
            }
        }
    };

    /**
     *
     */
    Actor.prototype.fullId = function () {
        return this.__device.id + "." + this.id;
    };

    /**
     *
     */
    Actor.prototype.fullLabel = function () {
        return this.__device.label + "." + this.label;
    };


    /**
     *
     */
    Actor.prototype.getService = function (id) {
        for (var n in this.__type.services) {
            if (this.__type.services[n].id === id) {
                return this.__type.services[n];
            }
        }

        throw "Cannot find Service [" + id + "].";
    };
}